/****************************************************************************
 * Copyright (C) 2014-2016 ecsec GmbH.
 * All rights reserved.
 * Contact: ecsec GmbH (info@ecsec.de)
 *
 * This file is part of SkIDentity.
 *
 * This file may be used in accordance with the terms and conditions
 * contained in a signed written agreement between you and ecsec GmbH.
 *
 ***************************************************************************/

import { Logger } from "./Logger";
import * as util from "./UtilFunctions";

export class Storage {

	private static logger = new Logger("skidentity.util.Storage");
	private static PREFIX: string = "SKIDJS_DATA";

	public static load(id: string): Object {
		this.logger.info("Loading Object for id: " + id);
		let res = null;
		res = window.sessionStorage.getItem(this.PREFIX + "." + id);

		if (res == null) {
			this.logger.info("Object for id: " + id + " is not in sessionStorage, try localStorage!");
			res = window.localStorage.getItem(this.PREFIX + "." + id);
		}
		if (res == null) {
			this.logger.error("Cannot load Object for id: " + id);
			throw new Error("NotFound");
		}

		this.logger.info("Found Object for id: " + id + " | " + res);
		return JSON.parse(res);
	}

	public static save(data: Object, persistent: boolean): string {
		let id = util.randomString(15);
		this.logger.info("Try to save Object with id: " + id + " and persistent: " + persistent + " | " + data);
		try {
			let t = this.load(id);
			if (t != null) {
				this.logger.warn("Id: " + id + " already exists!");
				this.save(data, persistent);
			}
		} catch (error) {
		}

		if (persistent) {
			this.logger.info("Save Object to localStorage. | " + data);
			window.localStorage.setItem(this.PREFIX + "." + id, JSON.stringify(data));
		} else {
			this.logger.info("Save Object to sessionStorage. | " + data);
			window.sessionStorage.setItem(this.PREFIX + "." + id, JSON.stringify(data));
		}
		return id;
	}

	public static remove(id: string): void {
		this.logger.info("Removing Object for id: " + id);
		let res = null;
		res = window.sessionStorage.getItem(this.PREFIX + "." + id);

		if (res != null) {
			window.sessionStorage.removeItem(this.PREFIX + "." + id);
			this.logger.info("Removed Object from sessionStorage for id: " + id);
		} else {
			this.logger.info("Object for id: " + id + " is not in sessionStorage, try localStorage!");
			res = window.localStorage.getItem(this.PREFIX + "." + id);

			if (res != null) {
				window.localStorage.removeItem(this.PREFIX + "." + id);
				this.logger.info("Removed Object from localStorage for id: " + id);
			} else {
				this.logger.error("No Object for id: " + id);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/@ecsec/base-libs/src/util/Storage.ts